import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { modulesApi } from "@/lib/admin-api/modules";
import { useModuleContext } from "@/context/ModuleContext";

// ---------------------------------------------------------------------------
// Query keys
// ---------------------------------------------------------------------------

const KEYS = {
  modules: ["admin-modules"] as const,
} as const;

// ---------------------------------------------------------------------------
// Queries
// ---------------------------------------------------------------------------

export function useModulesQuery() {
  return useQuery({
    queryKey: KEYS.modules,
    queryFn: () => modulesApi.list(),
    staleTime: 60_000,
    select: (data) => data.modules,
  });
}

// ---------------------------------------------------------------------------
// Mutations
// ---------------------------------------------------------------------------

export function useUpdateModule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      moduleKey,
      data,
    }: {
      readonly moduleKey: string;
      readonly data: { readonly isEnabled?: boolean; readonly regions?: string[] };
    }) => modulesApi.update(moduleKey, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEYS.modules });
    },
  });
}

// ---------------------------------------------------------------------------
// Context-based helper
// ---------------------------------------------------------------------------

export function useModuleEnabled(moduleKey: string, region?: string): boolean {
  const { isModuleEnabled } = useModuleContext();
  return isModuleEnabled(moduleKey, region);
}
